//@flow
import React from 'react';
import Icon from '../../Icon/components/Icon.react';
import Constants from '../../constants';

const HelpButton = () => {
  return (
    <a
      className="help-button-zendesk"
      href={Constants.SUPPORT_LINK}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Icon
        className="comment-icon"
        icon="comment"
        size="0.9rem"
        fill="#FFF"
      />
      Help
    </a>
  );
};

export default HelpButton;
